import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './call-to-action.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class CallToAction extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.text = '';
        this.target = '_blank';
        this.link = '';
        this.fontSize = '1.5em';
        this.marginBottom = '1em';
    }
    render() {
        const ctaClassNames = getStyleClassNames({
            fontSize: this.fontSize,
            marginBottom: this.marginBottom,
            isRtl: this.isRtl,
        });
        return x `<div class="${ctaClassNames}"><a href="${this.link}" target="${this.target}"><slot></slot></a></div>`;
    }
}
CallToAction.styles = css_248z;
__decorate([
    n({ type: Boolean })
], CallToAction.prototype, "isRtl", void 0);
__decorate([
    n({ type: String })
], CallToAction.prototype, "text", void 0);
__decorate([
    n({ type: String })
], CallToAction.prototype, "target", void 0);
__decorate([
    n({ type: String })
], CallToAction.prototype, "link", void 0);
__decorate([
    n({ type: String })
], CallToAction.prototype, "fontSize", void 0);
__decorate([
    n({ type: String })
], CallToAction.prototype, "marginBottom", void 0);
customElements.define('call-to-action', CallToAction);

export { CallToAction };
